import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatStates from '@medsurf/flat-states';
import * as FlatServices from '@medsurf/flat-services';

@Injectable()
export class ImageSharedFacade {
  constructor(protected store: Store,
              protected mediaControlService: FlatServices.MediaControlService) {
  }

  //<editor-fold desc="Selectors">

  config$ = this.store.select(FlatStates.ImageSharedState.config$);
  slide$ = this.store.select(FlatStates.PageEntityState.currentSelectedSlidePage$);
  image$ = this.store.select(FlatStates.ImageEntityState.currentSelectedSlideImage$);
  media$ = this.store.select(FlatStates.MediaEntityState.currentSelectedSlideMedia$);
  medias$ = this.store.select(FlatStates.MediaEntityState.currentSelectedSlideValidMedias$);
  annotations$ = this.store.select(FlatStates.ImageSharedState.annotations$);

  //</editor-fold>
}
